import React, { useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import * as Permission from "../../../services/permission.service";
import Breadcrums from "../../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
    FAQTYPES,
    permission_methods,
    SWAL_SETTINGS,
} from "../../../../../utils/Constants";
import {
    globalLoader,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../../utils/customError";

const PermissionAdd = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: 'Permission',
            url: "/admin/permission-management/permission/list/1",
        },
        { title: t("link_add"), url: "" },
    ];

    const validationSchema = Yup.object().shape({
        title: Yup.string().required(t("label_title_error")).test("no-spaces", "label_title_error", (value) => value.trim()),
        shortSlug: Yup.string().required(t("label_shortSlug_error")).test("no-spaces", "label_shortSlug_error", (value) => value.trim()),
        route: Yup.string().required(t("label_route_error")).test("no-spaces", "label_route_error", (value) => value.trim()),
        method: Yup.string().required(t("label_method_error")).test("no-spaces", "label_method_error", (value) => value.trim()),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: "",
            shortSlug: "",
            route: "",
            method: "",
            groupName: "",
        },
        validateOnBlur: false,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("title", values.title);
            formData.append("shortSlug", values.shortSlug);
            formData.append("route", values.route);
            formData.append("method", values.method);
            formData.append("groupName", values.groupName);

            Permission.Add(formData).then((response) => {
                setSubmitting(false);
                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                    globalLoader(false);
                    resetForm({ values: "" });
                    navigate(`/admin/permission-management/permission/list/1`);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(response),
                        ...SWAL_SETTINGS,
                    });
                    setSubmitted(false);
                    globalLoader(false);
                }
            })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        },
    });

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={formik.handleSubmit}>
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div>
                                    <h6 className="main-content-label mb-3">
                                        {t("link_add")} permissions
                                    </h6>
                                </div>
                                <div className="row row-sm">

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="question" className="text-left d-flex">
                                            {t("label_title")}
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="title"
                                            id="title"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.title}
                                            className="form-control"
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="title" form={formik} />
                                        </span>
                                    </div>

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="shortSlug" className="text-left d-flex">
                                            {t("label_shortSlug")}
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="shortSlug"
                                            id="shortSlug"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.shortSlug}
                                            className="form-control"
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="shortSlug" form={formik} />
                                        </span>
                                    </div>

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="groupName" className="text-left d-flex">
                                            Group Name
                                        </label>
                                        <input
                                            name="groupName"
                                            id="groupName"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.groupName}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="method" className="text-left d-flex">
                                            {t("label_method")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <div className=" select-down-arrow">
                                            <select
                                                name="method"
                                                id="method"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.status}
                                                className="form-control" >

                                                <option value="">{t("input_select_text")}</option>
                                                {Object.values(permission_methods).map((value, i) => {
                                                    return (
                                                        <option key={i} value={value}>
                                                            {value
                                                                .replace(/_/g, " ") // Replace underscores with spaces
                                                                .toLowerCase() // Convert to lowercase
                                                                .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="method" form={formik} />
                                        </span>
                                    </div>

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="route" className="text-left d-flex">
                                            {t("label_route")}
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="route"
                                            id="route"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.route}
                                            className="form-control"
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="route" form={formik} />
                                        </span>
                                    </div>

                                    <div className="mt-5">
                                        <button
                                            className="btn btn-info mr-2"
                                            type="submit"
                                            disabled={submitted ? true : null}
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("btn_submit")}
                                        </button>
                                        <button
                                            className="btn ripple btn-secondary"
                                            type="button"
                                            disabled={submitted ? true : null}
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                            {t("btn_cancel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default PermissionAdd;


